module.exports = "fonts/poppins-v9-latin-600.woff2";